
import Component, { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import ArtikelRow from "../custom/ArtikelRow.vue"
import moment from "moment"
import { AnforderungStatus, Bezahlart, Serviceanforderung } from "mangdto"
import FilialeHeader from "../custom/FilialeHeader.vue"
import DetailsSofortLogic from "@/logic/bestellung/details_sofort_logic"
import NachbestellungSheet from "../custom/NachbestellungSheet.vue"
import { EnumFormatter } from "mangutil"

@Component({ components: { ArtikelRow, FilialeHeader, NachbestellungSheet } })
export default class DetailsSofort extends mixins(Calculator) {
  logic: DetailsSofortLogic = new DetailsSofortLogic()

  berechneGesamtpreis(): number {
    return this.logic.berechneGesamtpreis()
  }

  serviceAbsenden() {
    this.logic.serviceAbsenden()
  }

  berechneGesamtpreisTrinkgeld(): number {
    return this.logic.berechneGesamtpreisTrinkgeld()
  }

  formatiereBoolean(value: boolean) {
    return value ? "ja" : "nein"
  }

  formatiereBezahlart(value: string) {
    switch (value) {
      case Bezahlart.Barzahlung:
        return "Zahlung an der Kasse"
      case Bezahlart.Paypal:
        return "PayPal"
    }
  }

  mounted() {
    this.logic = new DetailsSofortLogic()
    this.logic.init()
  }

  computeDauer(value: string): string {
    if (value == null) return null
    return moment(value).format("HH:mm")
  }

  computeStatusIcon(service: Serviceanforderung): string {
    if (service.status == AnforderungStatus.Offen) {
      return "mdi-timer-sand-empty"
    }
  }

  formatiereServiceStatus(value: AnforderungStatus): string {
    return EnumFormatter.formatAnforderungStatus(value)
  }

  serviceAnfordern() {
    this.logic.serviceAnfordern()
  }

  serviceanforderungErstellen() {
    this.logic.serviceanforderungErstellen()
  }

  nachbestellen() {
    this.logic.nachbestellen()
  }

  bezahlen() {
    this.logic.bezahlen()
  }
}
